import type { LHCDetails } from '@diamond/shared/types';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createLHC, updateLHC } from '../api';
import { COLLECTION_QUERY_KEYS } from '../api/constants';
import type { CreateLHCPayload, UpdateLHCPayload } from '../types';

export function useCreateLHCMutation(options?: {
  onSuccess?: (data: LHCDetails) => void;
  onError?: (error: Error) => void;
}) {
  const session = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateLHCPayload) =>
      createLHC(session.access_token, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [COLLECTION_QUERY_KEYS.LHC_LIST],
      });
      options?.onSuccess?.(data);
    },
    onError: options?.onError,
  });
}

export function useUpdateLHCMutation(options?: {
  onSuccess?: (data: LHCDetails) => void;
  onError?: (error: Error) => void;
}) {
  const session = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateLHCPayload }) =>
      updateLHC(session.access_token, id, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [COLLECTION_QUERY_KEYS.LHC_LIST],
      });
      options?.onSuccess?.(data);
    },
    onError: options?.onError,
  });
}
